import React, { useEffect, useState } from "react";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import { Comment, DealBtnPark } from "@/module";
import { Modal, Icon } from "antd";
import { checkResult, createFilePath, second2Date } from "@/common";
import "./style.less";

const NAME = "orgInfo";

const App = () => {
  const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
  const [[{ show, hide, width = 800, orgId = "", avatar }]] = useWatchState([
    "modal." + NAME,
  ]);

  const [data, setData] = useState({});

  useEffect(() => {
    if (orgId) {
      BaseService.list({
        table: "thtt_organization",
        columns: "name,profile",
        where: {
          organization_id: orgId,
          is_delete: 0,
        },
      }).then((res) => {
        if (!checkResult(res)) return;
        const data = res.data.result[0] || {};
        setData(data);
      });
    } else setData({});
  }, [orgId]);

  return (
    <Modal
      visible={show}
      width={width}
      maskClosable={false}
      destroyOnClose
      onCancel={hide}
      footer={false}
    >
      <h2>{data.name}</h2>
      <h3 className="m-md-t bold">Introduction</h3>

      {/* 产业园区机构背景介绍 */}

      {data.profile !== "<p></p>" && (
        <article className="m-md-t">
          <div
            className="m-sm-t braft-output-content"
            dangerouslySetInnerHTML={{ __html: data.profile }}
          ></div>
        </article>
      )}
    </Modal>
  );
};

export default App;
